module.exports = [{"name":"Presentation 2017","file":"/static/files/presentations/2017_alcomet.pdf","img":"/static/files/presentations/2017_alcomet.jpg","date":"01.01.2017"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/investors/presentations.json
// module id = jKKT
// module chunks = 1